// extracted by mini-css-extract-plugin
module.exports = {"appDescription":"Services_appDescription__PI5q1","add":"Services_add__Fg_3K"};